import React from 'react';
import { styled, Colors } from '../../themes';
import { Link, Img } from 'components';
import { device } from 'themes/media-queries';

interface Props {
  title: string;
  text: string;
  image: string;
  isCompany?: boolean;
}

const CategoryCard = (props: Props) => {
  const { title, text, image, isCompany, to } = props;
  return (
    <Container to={to}>
      <Content isCompany={isCompany}>
        <Title isCompany={isCompany}>{title}</Title>
        <Description isCompany={isCompany}>{text}</Description>
      </Content>
      <CategoryImage fluid={image.fluid} />
    </Container>
  );
};

const Container = styled(Link)`
  display: flex;
  flex-direction: column;
  box-shadow: 0 10px 30px 0 rgba(43, 44, 61, 0.25);
  scroll-snap-align: center;
  transition: all 0.2s;
  background-color: white;

  &:link,
  &:visited {
    text-decoration: none;
  }

  &:hover {
    transform: scale(1.05);
  }

  &:active {
    transform: scale(1);
  }

  @media ${device.mobileL} {
    &:hover {
      transform: none;
    }
  }
`;

const Content = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  padding: 2.5rem;

  background-color: ${({ isCompany }) => isCompany && Colors.almostBlack};
`;

const Title = styled.h3`
  font-size: 2.4rem;
  color: ${props =>
    props.isCompany
      ? props.theme.colors.paleOrange
      : props.theme.colors.darkOrange};
  text-decoration: none;
`;
const Description = styled.p`
  font-size: 1.7rem;
  color: ${props =>
    props.isCompany
      ? props.theme.colors.white
      : props.theme.colors.almostBlack};
`;

const CategoryImage = styled(Img)`
  width: 100%;
  object-fit: cover;
`;

export default CategoryCard;
